import {
  startAppointmentSummary,
  successAppointmentSummary,
  errorAppointmentSummary,
  startAppointment,
  successAppointment,
  errorAppointment,
  startPastAppointment,
  successPastAppointment,
  errorPastAppointment,
  startAppointmentCounter,
  successAppointmentCounter,
  errorAppointmentCounter,
  startSlot,
  successSlot,
  errorSlot,
  startCreateSlot,
  successCreateSlot,
  errorCreateSlot,
  startUnavailable,
  successUnavailable,
  errorUnavailable,
  startRangeUnavailable,
  successRangeUnavailable,
  errorRangeUnavailable,
  startAppointmentUnavailable,
  successAppointmentUnavailable,
  errorAppointmentUnavailable,
  startUpdateSlot,
  errorUpdateSlot,
  successUpdateSlot,
  startEditUnavailable,
  successEditUnavailable,
  errorEditUnavailable,
  startDeleteUnavailable,
  successDeleteUnavailable,
  errorDeleteUnavailable,
  startAppointmentDetail,
  successAppointmentDetail,
  errorAppointmentDetail,
  startDeleteSchedule,
  successDeleteSchedule,
  errorDeleteSchedule,
  startDeleteUnavailableSlot,
  successDeleteUnavailableSlot,
  errorDeleteUnavailableSlot,
  startFollowUpAppointment,
  successFollowUpAppointment,
  errorFollowUpAppointment,
  startFollowUpAppointmentCounter,
  successFollowUpAppointmentCounter,
  errorFollowUpAppointmentCounter,
} from "../../slice/Appointment";
import api from "../../instance/api";
import { errorUpdate } from "../../slice/Profile";

const getAppointmentSummary = (type) => async (dispatch) => {
  dispatch(startAppointmentSummary());

  try {
    const res = await api.get(`summary/appointment-summary/${type}`);
    dispatch(successAppointmentSummary(res.data));
  } catch (err) {
    dispatch(errorAppointmentSummary(err?.response?.data?.message));
  }
};

const getAppointment = (payload) => async (dispatch) => {
  dispatch(startAppointment());
  try {
    const requestBody = {
      offset: 0,
      limit: 5000,
      orderBy: "id",
      direction: "DESC",
      ...payload
    };
    const res = await api.post(
      `counsellor/appointments`,
      requestBody
    );

    dispatch(successAppointment(res.data));
    return res.data;
  } catch (err) {
    dispatch(errorAppointment(err?.response?.data?.message));
  }
};

const getPastAppointment = (payload, count) => async (dispatch) => {
  dispatch(startPastAppointment());
  try {
    const res = await api.post(
      `counsellor/appointments?offset=0&limit=${count}&orderBy=id&direction=DESC`,
      payload
    );

    dispatch(successPastAppointment(res.data));
  } catch (err) {
    dispatch(errorPastAppointment(err?.response?.data?.message));
  }
};

const getAppointmentCounter = (payload, count) => async (dispatch) => {
  dispatch(startAppointmentCounter());
  try {
    const res = await api.post(
      `counsellor/appointments?offset=0&limit=5000&orderBy=id&direction=DESC`,
      payload
    );

    dispatch(successAppointmentCounter(res.data));
  } catch (err) {
    dispatch(errorAppointmentCounter(err?.response?.data?.message));
  }
};

const getSlots = () => async (dispatch) => {
  dispatch(startSlot());
  try {
    const res = await api.get(`counsellor/bulk-schedule`);

    dispatch(successSlot(res.data));
  } catch (err) {
    dispatch(errorSlot(err?.response?.data?.message));
  }
};

const createSlots = (payload) => async (dispatch) => {
  dispatch(startCreateSlot());
  try {
    const res = await api.post(`counsellor/bulk-schedule`, payload);

    dispatch(successCreateSlot(res.data));
  } catch (err) {
    dispatch(errorCreateSlot(err?.response?.data));
  }
};

const updateSlots = (payload) => async (dispatch) => {
  dispatch(startUpdateSlot());
  try {
    const res = await api.put(`counsellor/schedule/updateSchedule`, payload);

    dispatch(successUpdateSlot(res.data));
  } catch (err) {
    console.log("error====>", err?.response?.data);
    dispatch(errorUpdateSlot(err?.response?.data));
  }
};

const createUnavialable = (payload) => async (dispatch) => {
  dispatch(startUnavailable());
  try {
    const res = await api.post(`counsellor/bulk-schedule/unavailable`, payload);

    dispatch(successUnavailable(res.data));
  } catch (err) {
    dispatch(errorUnavailable(err?.response?.data));
  }
};

const getUnavialable = () => async (dispatch) => {
  dispatch(startRangeUnavailable());
  try {
    const res = await api.get(`counsellor/bulk-schedule/unavailable`);

    dispatch(successRangeUnavailable(res.data));
  } catch (err) {
    dispatch(errorRangeUnavailable(err?.response?.data?.message));
  }
};

const getUnavialableAppointment = () => async (dispatch) => {
  dispatch(startAppointmentUnavailable());
  try {
    const res = await api.get(`counsellor/all-appointments/unavailable`);

    dispatch(successAppointmentUnavailable(res.data));
  } catch (err) {
    dispatch(errorAppointmentUnavailable(err?.response?.data?.message));
  }
};

const editUnavialable = (payload) => async (dispatch) => {
  dispatch(startEditUnavailable());
  try {
    const res = await api.put(`counsellor/bulk-schedule/unavailable`, payload);

    dispatch(successEditUnavailable(res.data));
  } catch (err) {
    dispatch(errorEditUnavailable(err?.response?.data));
  }
};

const deleteUnavialable = (payload) => async (dispatch) => {
  let cid = localStorage.getItem("cid");

  dispatch(startDeleteUnavailable());
  try {
    const res = await api.delete(`counsellor/${cid}/schedule/${payload}`);

    dispatch(successDeleteUnavailable(res.data));
  } catch (err) {
    dispatch(errorDeleteUnavailable(err?.response?.data));
  }
};

const getAppointmentDetailData = (payload) => async (dispatch) => {
  dispatch(startAppointmentDetail());
  try {
    const res = await api.get(`appointment/details/${payload}`);

    dispatch(successAppointmentDetail(res.data));
  } catch (err) {
    dispatch(errorAppointmentDetail(err?.response?.data));
  }
};

const deleteSchedule = (payload) => async (dispatch) => {
  dispatch(startDeleteSchedule());
  try {
    let cid = localStorage.getItem("cid");
    const res = await api.delete(`counsellor/${cid}/schedule/${payload}`);

    dispatch(successDeleteSchedule(res.data));
  } catch (err) {
    dispatch(errorDeleteSchedule(err?.response?.data));
  }
};

const deleteAllSchedule = () => async (dispatch) => {
  dispatch(startDeleteSchedule());
  try {
    let cid = localStorage.getItem("cid");
    const res = await api.delete(`counsellor/${cid}/schedules/delete-all`);

    dispatch(successDeleteSchedule(res.data));
  } catch (err) {
    dispatch(errorDeleteSchedule(err?.response?.data));
  }
};

const deleteAllUnavailable = () => async (dispatch) => {
  dispatch(startDeleteUnavailableSlot());
  try {
    let cid = localStorage.getItem("cid");
    const res = await api.delete(`counsellor/${cid}/unavailable/delete-all`);

    dispatch(successDeleteUnavailableSlot(res.data));
  } catch (err) {
    dispatch(errorDeleteUnavailableSlot(err?.response?.data));
  }
};

const getFollowUpAppointment = (payload) => async (dispatch) => {
  dispatch(startFollowUpAppointment());
  try {
    const requestBody = {
      offset: 0,
      limit: 5000,
      orderBy: "id",
      direction: "DESC",
      followUp: true,
      ...payload
    };
    const res = await api.post(
      `counsellor/appointments`,
      requestBody
    );

    dispatch(successFollowUpAppointment(res.data));
    return res.data;
  } catch (err) {
    dispatch(errorFollowUpAppointment(err?.response?.data?.message));
  }
};

const getFollowUpAppointmentCounter = (payload, count) => async (dispatch) => {
  dispatch(startFollowUpAppointmentCounter());
  try {
    const res = await api.post(
      `counsellor/appointments?offset=0&limit=5000&orderBy=id&direction=DESC&followUp=true`,
      payload
    );

    dispatch(successFollowUpAppointmentCounter(res.data));
  } catch (err) {
    dispatch(errorFollowUpAppointmentCounter(err?.response?.data?.message));
  }
};

export {
  getAppointmentSummary,
  getAppointment,
  getPastAppointment,
  getAppointmentCounter,
  getSlots,
  createSlots,
  updateSlots,
  createUnavialable,
  getUnavialable,
  getUnavialableAppointment,
  editUnavialable,
  deleteUnavialable,
  getAppointmentDetailData,
  deleteSchedule,
  deleteAllSchedule,
  deleteAllUnavailable,
  getFollowUpAppointment,
  getFollowUpAppointmentCounter,
};
